module.exports = __webpack_public_path__ + "static/media/OsloUniversityHospital.b62b2ec6.png";